var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blog-post date-style-1 blog-detail text-black"},[_c('h4',{staticClass:"widget-title text-uppercase"},[_vm._v("\n      "+_vm._s(_vm.$t(_vm.headline))+"\n    ")]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.getText(_vm.$store.state.i18n.currentLocale, 'text', 'WebPage', _vm.slug))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }